/**
 * @welldone-software/why-did-you-render 3.6.0
 * MIT Licensed
 * Generated by Vitali Zaidman <vzaidman@gmail.com> (https://github.com/vzaidman)
 * Generated at 2020-01-25
 */
!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = e || self).whyDidYouRender = t();
}(this, function () {
  "use strict";

  function e(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  function t(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }

  function r(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function n(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = null != arguments[n] ? arguments[n] : {};
      n % 2 ? r(Object(o), !0).forEach(function (r) {
        t(e, r, o[r]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : r(Object(o)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(o, t));
      });
    }

    return e;
  }

  function o(e) {
    return (o = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function a(e, t) {
    return (a = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function i(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function c(e, t, r) {
    return (c = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (e, t, r) {
      var n = function (e, t) {
        for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = o(e));) {
          ;
        }

        return e;
      }(e, t);

      if (n) {
        var a = Object.getOwnPropertyDescriptor(n, t);
        return a.get ? a.get.call(r) : a.value;
      }
    })(e, t, r || e);
  }

  function u(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if (!(Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e))) return;
      var r = [],
          n = !0,
          o = !1,
          a = void 0;

      try {
        for (var i, c = e[Symbol.iterator](); !(n = (i = c.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0) {
          ;
        }
      } catch (e) {
        o = !0, a = e;
      } finally {
        try {
          n || null == c.return || c.return();
        } finally {
          if (o) throw a;
        }
      }

      return r;
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }();
  }

  function f(e) {
    return function (e) {
      if (Array.isArray(e)) {
        for (var t = 0, r = new Array(e.length); t < e.length; t++) {
          r[t] = e[t];
        }

        return r;
      }
    }(e) || function (e) {
      if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
    }(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }();
  }

  var s = Array.isArray,
      l = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

  function p(e, t) {
    return e(t = {
      exports: {}
    }, t.exports), t.exports;
  }

  var v = "object" == typeof l && l && l.Object === Object && l,
      h = "object" == typeof self && self && self.Object === Object && self,
      y = v || h || Function("return this")(),
      d = y.Symbol,
      b = Object.prototype,
      g = b.hasOwnProperty,
      m = b.toString,
      _ = d ? d.toStringTag : void 0;

  var j = function j(e) {
    var t = g.call(e, _),
        r = e[_];

    try {
      e[_] = void 0;
      var n = !0;
    } catch (e) {}

    var o = m.call(e);
    return n && (t ? e[_] = r : delete e[_]), o;
  },
      O = Object.prototype.toString;

  var w = function w(e) {
    return O.call(e);
  },
      k = d ? d.toStringTag : void 0;

  var D = function D(e) {
    return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : k && k in Object(e) ? j(e) : w(e);
  };

  var S = function S(e) {
    return null != e && "object" == typeof e;
  };

  var P = function P(e) {
    return "symbol" == typeof e || S(e) && "[object Symbol]" == D(e);
  },
      R = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      E = /^\w*$/;

  var x = function x(e, t) {
    if (s(e)) return !1;
    var r = typeof e;
    return !("number" != r && "symbol" != r && "boolean" != r && null != e && !P(e)) || E.test(e) || !R.test(e) || null != t && e in Object(t);
  };

  var A = function A(e) {
    var t = typeof e;
    return null != e && ("object" == t || "function" == t);
  };

  var N,
      C = function C(e) {
    if (!A(e)) return !1;
    var t = D(e);
    return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
  },
      T = y["__core-js_shared__"],
      H = (N = /[^.]+$/.exec(T && T.keys && T.keys.IE_PROTO || "")) ? "Symbol(src)_1." + N : "";

  var Y = function Y(e) {
    return !!H && H in e;
  },
      z = Function.prototype.toString;

  var M = function M(e) {
    if (null != e) {
      try {
        return z.call(e);
      } catch (e) {}

      try {
        return e + "";
      } catch (e) {}
    }

    return "";
  },
      W = /^\[object .+?Constructor\]$/,
      F = Function.prototype,
      L = Object.prototype,
      $ = F.toString,
      I = L.hasOwnProperty,
      V = RegExp("^" + $.call(I).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

  var U = function U(e) {
    return !(!A(e) || Y(e)) && (C(e) ? V : W).test(M(e));
  };

  var B = function B(e, t) {
    return null == e ? void 0 : e[t];
  };

  var G = function G(e, t) {
    var r = B(e, t);
    return U(r) ? r : void 0;
  },
      q = G(Object, "create");

  var J = function J() {
    this.__data__ = q ? q(null) : {}, this.size = 0;
  };

  var K = function K(e) {
    var t = this.has(e) && delete this.__data__[e];
    return this.size -= t ? 1 : 0, t;
  },
      Q = Object.prototype.hasOwnProperty;

  var X = function X(e) {
    var t = this.__data__;

    if (q) {
      var r = t[e];
      return "__lodash_hash_undefined__" === r ? void 0 : r;
    }

    return Q.call(t, e) ? t[e] : void 0;
  },
      Z = Object.prototype.hasOwnProperty;

  var ee = function ee(e) {
    var t = this.__data__;
    return q ? void 0 !== t[e] : Z.call(t, e);
  };

  var te = function te(e, t) {
    var r = this.__data__;
    return this.size += this.has(e) ? 0 : 1, r[e] = q && void 0 === t ? "__lodash_hash_undefined__" : t, this;
  };

  function re(e) {
    var t = -1,
        r = null == e ? 0 : e.length;

    for (this.clear(); ++t < r;) {
      var n = e[t];
      this.set(n[0], n[1]);
    }
  }

  re.prototype.clear = J, re.prototype.delete = K, re.prototype.get = X, re.prototype.has = ee, re.prototype.set = te;
  var ne = re;

  var oe = function oe() {
    this.__data__ = [], this.size = 0;
  };

  var ae = function ae(e, t) {
    return e === t || e != e && t != t;
  };

  var ie = function ie(e, t) {
    for (var r = e.length; r--;) {
      if (ae(e[r][0], t)) return r;
    }

    return -1;
  },
      ce = Array.prototype.splice;

  var ue = function ue(e) {
    var t = this.__data__,
        r = ie(t, e);
    return !(r < 0) && (r == t.length - 1 ? t.pop() : ce.call(t, r, 1), --this.size, !0);
  };

  var fe = function fe(e) {
    var t = this.__data__,
        r = ie(t, e);
    return r < 0 ? void 0 : t[r][1];
  };

  var se = function se(e) {
    return ie(this.__data__, e) > -1;
  };

  var le = function le(e, t) {
    var r = this.__data__,
        n = ie(r, e);
    return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
  };

  function pe(e) {
    var t = -1,
        r = null == e ? 0 : e.length;

    for (this.clear(); ++t < r;) {
      var n = e[t];
      this.set(n[0], n[1]);
    }
  }

  pe.prototype.clear = oe, pe.prototype.delete = ue, pe.prototype.get = fe, pe.prototype.has = se, pe.prototype.set = le;
  var ve = pe,
      he = G(y, "Map");

  var ye = function ye() {
    this.size = 0, this.__data__ = {
      hash: new ne(),
      map: new (he || ve)(),
      string: new ne()
    };
  };

  var de = function de(e) {
    var t = typeof e;
    return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e : null === e;
  };

  var be = function be(e, t) {
    var r = e.__data__;
    return de(t) ? r["string" == typeof t ? "string" : "hash"] : r.map;
  };

  var ge = function ge(e) {
    var t = be(this, e).delete(e);
    return this.size -= t ? 1 : 0, t;
  };

  var me = function me(e) {
    return be(this, e).get(e);
  };

  var _e = function _e(e) {
    return be(this, e).has(e);
  };

  var je = function je(e, t) {
    var r = be(this, e),
        n = r.size;
    return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
  };

  function Oe(e) {
    var t = -1,
        r = null == e ? 0 : e.length;

    for (this.clear(); ++t < r;) {
      var n = e[t];
      this.set(n[0], n[1]);
    }
  }

  Oe.prototype.clear = ye, Oe.prototype.delete = ge, Oe.prototype.get = me, Oe.prototype.has = _e, Oe.prototype.set = je;
  var we = Oe;

  function ke(e, t) {
    if ("function" != typeof e || null != t && "function" != typeof t) throw new TypeError("Expected a function");

    var r = function r() {
      var n = arguments,
          o = t ? t.apply(this, n) : n[0],
          a = r.cache;
      if (a.has(o)) return a.get(o);
      var i = e.apply(this, n);
      return r.cache = a.set(o, i) || a, i;
    };

    return r.cache = new (ke.Cache || we)(), r;
  }

  ke.Cache = we;
  var De = ke;

  var Se = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
      Pe = /\\(\\)?/g,
      Re = function (e) {
    var t = De(e, function (e) {
      return 500 === r.size && r.clear(), e;
    }),
        r = t.cache;
    return t;
  }(function (e) {
    var t = [];
    return 46 === e.charCodeAt(0) && t.push(""), e.replace(Se, function (e, r, n, o) {
      t.push(n ? o.replace(Pe, "$1") : r || e);
    }), t;
  });

  var Ee = function Ee(e, t) {
    for (var r = -1, n = null == e ? 0 : e.length, o = Array(n); ++r < n;) {
      o[r] = t(e[r], r, e);
    }

    return o;
  },
      xe = d ? d.prototype : void 0,
      Ae = xe ? xe.toString : void 0;

  var Ne = function e(t) {
    if ("string" == typeof t) return t;
    if (s(t)) return Ee(t, e) + "";
    if (P(t)) return Ae ? Ae.call(t) : "";
    var r = t + "";
    return "0" == r && 1 / t == -1 / 0 ? "-0" : r;
  };

  var Ce = function Ce(e) {
    return null == e ? "" : Ne(e);
  };

  var Te = function Te(e, t) {
    return s(e) ? e : x(e, t) ? [e] : Re(Ce(e));
  };

  var He = function He(e) {
    if ("string" == typeof e || P(e)) return e;
    var t = e + "";
    return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
  };

  var Ye = function Ye(e, t) {
    for (var r = 0, n = (t = Te(t, e)).length; null != e && r < n;) {
      e = e[He(t[r++])];
    }

    return r && r == n ? e : void 0;
  };

  var ze,
      Me = function Me(e, t, r) {
    var n = null == e ? void 0 : Ye(e, t);
    return void 0 === n ? r : n;
  },
      We = "different",
      Fe = "deepEquals",
      Le = "date",
      $e = "regex",
      Ie = "reactElement",
      Ve = "function",
      Ue = "function" == typeof Symbol && Symbol.for,
      Be = Ue ? Symbol.for("react.memo") : 60115,
      Ge = Ue ? Symbol.for("react.forward_ref") : 60112,
      qe = (t(ze = {}, We, "different objects."), t(ze, Fe, "different objects that are equal by value."), t(ze, Le, "different date objects with the same value."), t(ze, $e, "different regular expressions with the same value."), t(ze, Ie, "different React elements with the same displayName."), t(ze, Ve, "different functions with the same name."), ze),
      Je = !1;

  function Ke(e) {
    var r = e.Component,
        n = e.displayName,
        o = e.hookName,
        a = e.prefixMessage,
        i = e.diffObjType,
        c = e.differences,
        u = e.values,
        f = e.options;
    c && c.length > 0 ? (f.consoleLog(t({}, n, r), "".concat(a, " of ").concat(i, " changes:")), c.forEach(function (e) {
      var r = e.pathString,
          n = e.diffType,
          a = e.prevValue,
          c = e.nextValue;
      f.consoleGroup("%c".concat("hook" === i ? "[hook ".concat(o, " result]") : "".concat(i, "."), "%c").concat(r, "%c"), "color:".concat(f.diffNameColor, ";"), "color:".concat(f.diffPathColor, ";"), "color:default;"), f.consoleLog("".concat(qe[n], " (more info at ").concat(o ? "http://bit.ly/wdyr3" : "http://bit.ly/wdyr02", ")")), f.consoleLog(t({}, "prev ".concat(r), a), "!==", t({}, "next ".concat(r), c)), f.consoleGroupEnd();
    })) : c && (f.consoleLog(t({}, n, r), "".concat(a, " the ").concat(i, " object itself changed but its values are all equal."), "props" === i ? "This could have been avoided by making the component pure, or by preventing its father from re-rendering." : "This usually means this component called setState when no changes in its state actually occurred.", "More info at ".concat("http://bit.ly/wdyr02")), f.consoleLog("prev ".concat(i, ":"), u.prev, " !== ", u.next, ":next ".concat(i)));
  }

  function Qe(e) {
    var r = e.Component,
        n = e.displayName,
        o = e.hookName,
        a = e.prevProps,
        i = e.prevState,
        c = e.prevHook,
        u = e.nextProps,
        f = e.nextState,
        s = e.nextHook,
        l = e.reason,
        p = e.options;

    if (function (e, t, r) {
      return !Je && (!!r.logOnDifferentValues || !(!t.whyDidYouRender || !t.whyDidYouRender.logOnDifferentValues) || !(e.propsDifferences && e.propsDifferences.some(function (e) {
        return e.diffType === We;
      }) || e.stateDifferences && e.stateDifferences.some(function (e) {
        return e.diffType === We;
      }) || e.hookDifferences && e.hookDifferences.some(function (e) {
        return e.diffType === We;
      })));
    }(l, r, p)) {
      p.consoleGroup("%c".concat(n), "color: ".concat(p.titleColor, ";"));
      var v = "Re-rendered because";
      l.propsDifferences && (Ke({
        Component: r,
        displayName: n,
        prefixMessage: v,
        diffObjType: "props",
        differences: l.propsDifferences,
        values: {
          prev: a,
          next: u
        },
        options: p
      }), v = "And because"), l.stateDifferences && Ke({
        Component: r,
        displayName: n,
        prefixMessage: v,
        diffObjType: "state",
        differences: l.stateDifferences,
        values: {
          prev: i,
          next: f
        },
        options: p
      }), l.hookDifferences && Ke({
        Component: r,
        displayName: n,
        prefixMessage: v,
        diffObjType: "hook",
        differences: l.hookDifferences,
        values: {
          prev: c,
          next: s
        },
        hookName: o,
        options: p
      }), l.propsDifferences || l.stateDifferences || l.hookDifferences || p.consoleLog(t({}, n, r), "Re-rendered although props and state objects are the same.", "This usually means there was a call to this.forceUpdate() inside the component.", "more info at ".concat("http://bit.ly/wdyr02")), p.consoleGroupEnd();
    }
  }

  function Xe(e) {
    return e && "undefined" != typeof module && module.hot && module.hot.addStatusHandler && module.hot.addStatusHandler(function (t) {
      "idle" === t && (Je = !0, setTimeout(function () {
        Je = !1;
      }, e));
    }), Qe;
  }

  var Ze = function Ze() {};

  var et = function et(e) {
    return "string" == typeof e || !s(e) && S(e) && "[object String]" == D(e);
  };

  function tt(e) {
    return e.displayName || e.name || e.type && tt(e.type) || e.render && tt(e.render) || (et(e) ? e : void 0);
  }

  var rt = function rt(e, t, r, n) {
    var o = -1,
        a = null == e ? 0 : e.length;

    for (n && a && (r = e[++o]); ++o < a;) {
      r = t(r, e[o], o, e);
    }

    return r;
  };

  var nt = function (e) {
    return function (t, r, n) {
      for (var o = -1, a = Object(t), i = n(t), c = i.length; c--;) {
        var u = i[e ? c : ++o];
        if (!1 === r(a[u], u, a)) break;
      }

      return t;
    };
  }();

  var ot = function ot(e, t) {
    for (var r = -1, n = Array(e); ++r < e;) {
      n[r] = t(r);
    }

    return n;
  };

  var at = function at(e) {
    return S(e) && "[object Arguments]" == D(e);
  },
      it = Object.prototype,
      ct = it.hasOwnProperty,
      ut = it.propertyIsEnumerable,
      ft = at(function () {
    return arguments;
  }()) ? at : function (e) {
    return S(e) && ct.call(e, "callee") && !ut.call(e, "callee");
  };

  var st = function st() {
    return !1;
  },
      lt = p(function (e, t) {
    var r = t && !t.nodeType && t,
        n = r && e && !e.nodeType && e,
        o = n && n.exports === r ? y.Buffer : void 0,
        a = (o ? o.isBuffer : void 0) || st;
    e.exports = a;
  }),
      pt = /^(?:0|[1-9]\d*)$/;

  var vt = function vt(e, t) {
    var r = typeof e;
    return !!(t = null == t ? 9007199254740991 : t) && ("number" == r || "symbol" != r && pt.test(e)) && e > -1 && e % 1 == 0 && e < t;
  };

  var ht = function ht(e) {
    return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
  },
      yt = {};

  yt["[object Float32Array]"] = yt["[object Float64Array]"] = yt["[object Int8Array]"] = yt["[object Int16Array]"] = yt["[object Int32Array]"] = yt["[object Uint8Array]"] = yt["[object Uint8ClampedArray]"] = yt["[object Uint16Array]"] = yt["[object Uint32Array]"] = !0, yt["[object Arguments]"] = yt["[object Array]"] = yt["[object ArrayBuffer]"] = yt["[object Boolean]"] = yt["[object DataView]"] = yt["[object Date]"] = yt["[object Error]"] = yt["[object Function]"] = yt["[object Map]"] = yt["[object Number]"] = yt["[object Object]"] = yt["[object RegExp]"] = yt["[object Set]"] = yt["[object String]"] = yt["[object WeakMap]"] = !1;

  var dt = function dt(e) {
    return S(e) && ht(e.length) && !!yt[D(e)];
  };

  var bt = function bt(e) {
    return function (t) {
      return e(t);
    };
  },
      gt = p(function (e, t) {
    var r = t && !t.nodeType && t,
        n = r && e && !e.nodeType && e,
        o = n && n.exports === r && v.process,
        a = function () {
      try {
        var e = n && n.require && n.require("util").types;

        return e || o && o.binding && o.binding("util");
      } catch (e) {}
    }();

    e.exports = a;
  }),
      mt = gt && gt.isTypedArray,
      _t = mt ? bt(mt) : dt,
      jt = Object.prototype.hasOwnProperty;

  var Ot = function Ot(e, t) {
    var r = s(e),
        n = !r && ft(e),
        o = !r && !n && lt(e),
        a = !r && !n && !o && _t(e),
        i = r || n || o || a,
        c = i ? ot(e.length, String) : [],
        u = c.length;

    for (var f in e) {
      !t && !jt.call(e, f) || i && ("length" == f || o && ("offset" == f || "parent" == f) || a && ("buffer" == f || "byteLength" == f || "byteOffset" == f) || vt(f, u)) || c.push(f);
    }

    return c;
  },
      wt = Object.prototype;

  var kt = function kt(e) {
    var t = e && e.constructor;
    return e === ("function" == typeof t && t.prototype || wt);
  };

  var Dt = function Dt(e, t) {
    return function (r) {
      return e(t(r));
    };
  },
      St = Dt(Object.keys, Object),
      Pt = Object.prototype.hasOwnProperty;

  var Rt = function Rt(e) {
    if (!kt(e)) return St(e);
    var t = [];

    for (var r in Object(e)) {
      Pt.call(e, r) && "constructor" != r && t.push(r);
    }

    return t;
  };

  var Et = function Et(e) {
    return null != e && ht(e.length) && !C(e);
  };

  var xt = function xt(e) {
    return Et(e) ? Ot(e) : Rt(e);
  };

  var At = function (e, t) {
    return function (r, n) {
      if (null == r) return r;
      if (!Et(r)) return e(r, n);

      for (var o = r.length, a = t ? o : -1, i = Object(r); (t ? a-- : ++a < o) && !1 !== n(i[a], a, i);) {
        ;
      }

      return r;
    };
  }(function (e, t) {
    return e && nt(e, t, xt);
  });

  var Nt = function Nt() {
    this.__data__ = new ve(), this.size = 0;
  };

  var Ct = function Ct(e) {
    var t = this.__data__,
        r = t.delete(e);
    return this.size = t.size, r;
  };

  var Tt = function Tt(e) {
    return this.__data__.get(e);
  };

  var Ht = function Ht(e) {
    return this.__data__.has(e);
  };

  var Yt = function Yt(e, t) {
    var r = this.__data__;

    if (r instanceof ve) {
      var n = r.__data__;
      if (!he || n.length < 199) return n.push([e, t]), this.size = ++r.size, this;
      r = this.__data__ = new we(n);
    }

    return r.set(e, t), this.size = r.size, this;
  };

  function zt(e) {
    var t = this.__data__ = new ve(e);
    this.size = t.size;
  }

  zt.prototype.clear = Nt, zt.prototype.delete = Ct, zt.prototype.get = Tt, zt.prototype.has = Ht, zt.prototype.set = Yt;
  var Mt = zt;

  var Wt = function Wt(e) {
    return this.__data__.set(e, "__lodash_hash_undefined__"), this;
  };

  var Ft = function Ft(e) {
    return this.__data__.has(e);
  };

  function Lt(e) {
    var t = -1,
        r = null == e ? 0 : e.length;

    for (this.__data__ = new we(); ++t < r;) {
      this.add(e[t]);
    }
  }

  Lt.prototype.add = Lt.prototype.push = Wt, Lt.prototype.has = Ft;
  var $t = Lt;

  var It = function It(e, t) {
    for (var r = -1, n = null == e ? 0 : e.length; ++r < n;) {
      if (t(e[r], r, e)) return !0;
    }

    return !1;
  };

  var Vt = function Vt(e, t) {
    return e.has(t);
  };

  var Ut = function Ut(e, t, r, n, o, a) {
    var i = 1 & r,
        c = e.length,
        u = t.length;
    if (c != u && !(i && u > c)) return !1;
    var f = a.get(e);
    if (f && a.get(t)) return f == t;
    var s = -1,
        l = !0,
        p = 2 & r ? new $t() : void 0;

    for (a.set(e, t), a.set(t, e); ++s < c;) {
      var v = e[s],
          h = t[s];
      if (n) var y = i ? n(h, v, s, t, e, a) : n(v, h, s, e, t, a);

      if (void 0 !== y) {
        if (y) continue;
        l = !1;
        break;
      }

      if (p) {
        if (!It(t, function (e, t) {
          if (!Vt(p, t) && (v === e || o(v, e, r, n, a))) return p.push(t);
        })) {
          l = !1;
          break;
        }
      } else if (v !== h && !o(v, h, r, n, a)) {
        l = !1;
        break;
      }
    }

    return a.delete(e), a.delete(t), l;
  },
      Bt = y.Uint8Array;

  var Gt = function Gt(e) {
    var t = -1,
        r = Array(e.size);
    return e.forEach(function (e, n) {
      r[++t] = [n, e];
    }), r;
  };

  var qt = function qt(e) {
    var t = -1,
        r = Array(e.size);
    return e.forEach(function (e) {
      r[++t] = e;
    }), r;
  },
      Jt = d ? d.prototype : void 0,
      Kt = Jt ? Jt.valueOf : void 0;

  var Qt = function Qt(e, t, r, n, o, a, i) {
    switch (r) {
      case "[object DataView]":
        if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
        e = e.buffer, t = t.buffer;

      case "[object ArrayBuffer]":
        return !(e.byteLength != t.byteLength || !a(new Bt(e), new Bt(t)));

      case "[object Boolean]":
      case "[object Date]":
      case "[object Number]":
        return ae(+e, +t);

      case "[object Error]":
        return e.name == t.name && e.message == t.message;

      case "[object RegExp]":
      case "[object String]":
        return e == t + "";

      case "[object Map]":
        var c = Gt;

      case "[object Set]":
        var u = 1 & n;
        if (c || (c = qt), e.size != t.size && !u) return !1;
        var f = i.get(e);
        if (f) return f == t;
        n |= 2, i.set(e, t);
        var s = Ut(c(e), c(t), n, o, a, i);
        return i.delete(e), s;

      case "[object Symbol]":
        if (Kt) return Kt.call(e) == Kt.call(t);
    }

    return !1;
  };

  var Xt = function Xt(e, t) {
    for (var r = -1, n = t.length, o = e.length; ++r < n;) {
      e[o + r] = t[r];
    }

    return e;
  };

  var Zt = function Zt(e, t, r) {
    var n = t(e);
    return s(e) ? n : Xt(n, r(e));
  };

  var er = function er(e, t) {
    for (var r = -1, n = null == e ? 0 : e.length, o = 0, a = []; ++r < n;) {
      var i = e[r];
      t(i, r, e) && (a[o++] = i);
    }

    return a;
  };

  var tr = function tr() {
    return [];
  },
      rr = Object.prototype.propertyIsEnumerable,
      nr = Object.getOwnPropertySymbols,
      or = nr ? function (e) {
    return null == e ? [] : (e = Object(e), er(nr(e), function (t) {
      return rr.call(e, t);
    }));
  } : tr;

  var ar = function ar(e) {
    return Zt(e, xt, or);
  },
      ir = Object.prototype.hasOwnProperty;

  var cr = function cr(e, t, r, n, o, a) {
    var i = 1 & r,
        c = ar(e),
        u = c.length;
    if (u != ar(t).length && !i) return !1;

    for (var f = u; f--;) {
      var s = c[f];
      if (!(i ? s in t : ir.call(t, s))) return !1;
    }

    var l = a.get(e);
    if (l && a.get(t)) return l == t;
    var p = !0;
    a.set(e, t), a.set(t, e);

    for (var v = i; ++f < u;) {
      var h = e[s = c[f]],
          y = t[s];
      if (n) var d = i ? n(y, h, s, t, e, a) : n(h, y, s, e, t, a);

      if (!(void 0 === d ? h === y || o(h, y, r, n, a) : d)) {
        p = !1;
        break;
      }

      v || (v = "constructor" == s);
    }

    if (p && !v) {
      var b = e.constructor,
          g = t.constructor;
      b != g && "constructor" in e && "constructor" in t && !("function" == typeof b && b instanceof b && "function" == typeof g && g instanceof g) && (p = !1);
    }

    return a.delete(e), a.delete(t), p;
  },
      ur = G(y, "DataView"),
      fr = G(y, "Promise"),
      sr = G(y, "Set"),
      lr = G(y, "WeakMap"),
      pr = M(ur),
      vr = M(he),
      hr = M(fr),
      yr = M(sr),
      dr = M(lr),
      br = D;

  (ur && "[object DataView]" != br(new ur(new ArrayBuffer(1))) || he && "[object Map]" != br(new he()) || fr && "[object Promise]" != br(fr.resolve()) || sr && "[object Set]" != br(new sr()) || lr && "[object WeakMap]" != br(new lr())) && (br = function br(e) {
    var t = D(e),
        r = "[object Object]" == t ? e.constructor : void 0,
        n = r ? M(r) : "";
    if (n) switch (n) {
      case pr:
        return "[object DataView]";

      case vr:
        return "[object Map]";

      case hr:
        return "[object Promise]";

      case yr:
        return "[object Set]";

      case dr:
        return "[object WeakMap]";
    }
    return t;
  });
  var gr = br,
      mr = Object.prototype.hasOwnProperty;

  var _r = function _r(e, t, r, n, o, a) {
    var i = s(e),
        c = s(t),
        u = i ? "[object Array]" : gr(e),
        f = c ? "[object Array]" : gr(t),
        l = "[object Object]" == (u = "[object Arguments]" == u ? "[object Object]" : u),
        p = "[object Object]" == (f = "[object Arguments]" == f ? "[object Object]" : f),
        v = u == f;

    if (v && lt(e)) {
      if (!lt(t)) return !1;
      i = !0, l = !1;
    }

    if (v && !l) return a || (a = new Mt()), i || _t(e) ? Ut(e, t, r, n, o, a) : Qt(e, t, u, r, n, o, a);

    if (!(1 & r)) {
      var h = l && mr.call(e, "__wrapped__"),
          y = p && mr.call(t, "__wrapped__");

      if (h || y) {
        var d = h ? e.value() : e,
            b = y ? t.value() : t;
        return a || (a = new Mt()), o(d, b, r, n, a);
      }
    }

    return !!v && (a || (a = new Mt()), cr(e, t, r, n, o, a));
  };

  var jr = function e(t, r, n, o, a) {
    return t === r || (null == t || null == r || !S(t) && !S(r) ? t != t && r != r : _r(t, r, n, o, e, a));
  };

  var Or = function Or(e, t, r, n) {
    var o = r.length,
        a = o,
        i = !n;
    if (null == e) return !a;

    for (e = Object(e); o--;) {
      var c = r[o];
      if (i && c[2] ? c[1] !== e[c[0]] : !(c[0] in e)) return !1;
    }

    for (; ++o < a;) {
      var u = (c = r[o])[0],
          f = e[u],
          s = c[1];

      if (i && c[2]) {
        if (void 0 === f && !(u in e)) return !1;
      } else {
        var l = new Mt();
        if (n) var p = n(f, s, u, e, t, l);
        if (!(void 0 === p ? jr(s, f, 3, n, l) : p)) return !1;
      }
    }

    return !0;
  };

  var wr = function wr(e) {
    return e == e && !A(e);
  };

  var kr = function kr(e) {
    for (var t = xt(e), r = t.length; r--;) {
      var n = t[r],
          o = e[n];
      t[r] = [n, o, wr(o)];
    }

    return t;
  };

  var Dr = function Dr(e, t) {
    return function (r) {
      return null != r && r[e] === t && (void 0 !== t || e in Object(r));
    };
  };

  var Sr = function Sr(e) {
    var t = kr(e);
    return 1 == t.length && t[0][2] ? Dr(t[0][0], t[0][1]) : function (r) {
      return r === e || Or(r, e, t);
    };
  };

  var Pr = function Pr(e, t) {
    return null != e && t in Object(e);
  };

  var Rr = function Rr(e, t, r) {
    for (var n = -1, o = (t = Te(t, e)).length, a = !1; ++n < o;) {
      var i = He(t[n]);
      if (!(a = null != e && r(e, i))) break;
      e = e[i];
    }

    return a || ++n != o ? a : !!(o = null == e ? 0 : e.length) && ht(o) && vt(i, o) && (s(e) || ft(e));
  };

  var Er = function Er(e, t) {
    return null != e && Rr(e, t, Pr);
  };

  var xr = function xr(e, t) {
    return x(e) && wr(t) ? Dr(He(e), t) : function (r) {
      var n = Me(r, e);
      return void 0 === n && n === t ? Er(r, e) : jr(t, n, 3);
    };
  };

  var Ar = function Ar(e) {
    return e;
  };

  var Nr = function Nr(e) {
    return function (t) {
      return null == t ? void 0 : t[e];
    };
  };

  var Cr = function Cr(e) {
    return function (t) {
      return Ye(t, e);
    };
  };

  var Tr = function Tr(e) {
    return x(e) ? Nr(He(e)) : Cr(e);
  };

  var Hr = function Hr(e) {
    return "function" == typeof e ? e : null == e ? Ar : "object" == typeof e ? s(e) ? xr(e[0], e[1]) : Sr(e) : Tr(e);
  };

  var Yr = function Yr(e, t, r, n, o) {
    return o(e, function (e, o, a) {
      r = n ? (n = !1, e) : t(r, e, o, a);
    }), r;
  };

  var zr = function zr(e, t, r) {
    var n = s(e) ? rt : Yr,
        o = arguments.length < 3;
    return n(e, Hr(t), r, o, At);
  },
      Mr = Object.prototype.hasOwnProperty;

  var Wr = function Wr(e, t) {
    return null != e && Mr.call(e, t);
  };

  var Fr = function Fr(e, t) {
    return null != e && Rr(e, t, Wr);
  };

  var Lr = function Lr(e) {
    return S(e) && "[object RegExp]" == D(e);
  },
      $r = gt && gt.isRegExp,
      Ir = $r ? bt($r) : Lr;

  var Vr = function Vr(e) {
    return S(e) && "[object Date]" == D(e);
  },
      Ur = gt && gt.isDate,
      Br = Ur ? bt(Ur) : Vr,
      Gr = Dt(Object.getPrototypeOf, Object),
      qr = Function.prototype,
      Jr = Object.prototype,
      Kr = qr.toString,
      Qr = Jr.hasOwnProperty,
      Xr = Kr.call(Object);

  var Zr = function Zr(e) {
    if (!S(e) || "[object Object]" != D(e)) return !1;
    var t = Gr(e);
    if (null === t) return !0;
    var r = Qr.call(t, "constructor") && t.constructor;
    return "function" == typeof r && r instanceof r && Kr.call(r) == Xr;
  },
      en = "undefined" != typeof Element,
      tn = "function" == typeof Symbol && Symbol.for ? Symbol.for("react.element") : 60103,
      rn = function rn(e) {
    return e.$$typeof === tn;
  };

  function nn(e, t, r, n, o) {
    return r.push({
      diffType: o,
      pathString: n,
      prevValue: e,
      nextValue: t
    }), o !== We;
  }

  function on(e, t, r) {
    try {
      var n = [];
      return function e(t, r, n) {
        var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "";
        if (t === r) return !0;
        if (!t || !r) return nn(t, r, n, o, We);

        if (s(t) && s(r)) {
          var a = t.length;
          if (a !== r.length) return nn(t, r, n, o, We);

          for (var i = !0, c = a; 0 != c--;) {
            e(t[c], r[c], n, "".concat(o, "[").concat(c, "]")) || (i = !1);
          }

          return nn(t, r, n, o, i ? Fe : We);
        }

        if (Br(t) && Br(r)) return t.getTime() === r.getTime() ? nn(t, r, n, o, Le) : nn(t, r, n, o, We);
        if (Ir(t) && Ir(r)) return t.toString() === r.toString() ? nn(t, r, n, o, $e) : nn(t, r, n, o, We);
        if (en && t instanceof Element && r instanceof Element) return nn(t, r, n, o, We);

        if (rn(t) && rn(r)) {
          if (t.type !== r.type) return nn(t, r, n, o, We);
          var u = e(t.props, r.props, n, "".concat(o, ".props"));
          return nn(t, r, n, o, u ? Ie : We);
        }

        if (C(t) && C(r)) return t.name === r.name ? nn(t, r, n, o, Ve) : nn(t, r, n, o, We);

        if (Zr(t) && Zr(r)) {
          var f = xt(t),
              l = f.length;
          if (l !== xt(r).length) return nn(t, r, n, o, We);

          for (var p = l; 0 != p--;) {
            if (!Fr(r, f[p])) return nn(t, r, n, o, We);
          }

          for (var v = !0, h = l; 0 != h--;) {
            var y = f[h];
            e(t[y], r[y], n, "".concat(o, ".").concat(y)) || (v = !1);
          }

          return nn(t, r, n, o, v ? Fe : We);
        }

        return nn(t, r, n, o, We);
      }(e, t, n, r), n;
    } catch (e) {
      if (e.message && e.message.match(/stack|recursion/i) || -2146828260 === e.number) return console.warn("Warning: why-did-you-render couldn't handle circular references in props.", e.name, e.message), !1;
      throw e;
    }
  }

  var an = {};

  function cn(e, t) {
    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
        o = r.shallow,
        a = void 0 === o || o;
    if (e === t) return !1;
    if (!a) return on(e, t);
    var i = e || an,
        c = t || an,
        u = Object.keys(n({}, i, {}, c));
    return zr(u, function (e, t) {
      var r = on(i[t], c[t], t);
      return r && (e = [].concat(f(e), f(r))), e;
    }, []);
  }

  function un(e, t, r, n, o, a) {
    return {
      propsDifferences: cn(e, n),
      stateDifferences: cn(t, o),
      hookDifferences: cn(r, a, {
        shallow: !1
      })
    };
  }

  function fn(e) {
    var t = e.Component,
        r = e.displayName,
        n = e.hookName,
        o = e.prevProps,
        a = e.prevState,
        i = e.prevHook,
        c = e.nextProps,
        u = e.nextState,
        f = e.nextHook;
    return {
      Component: t,
      displayName: r,
      hookName: n,
      prevProps: o,
      prevState: a,
      prevHook: i,
      nextProps: c,
      nextState: u,
      nextHook: f,
      options: e.options,
      reason: un(o, a, i, c, u, f)
    };
  }

  function sn(e) {
    return e.prototype && !!e.prototype.isReactComponent;
  }

  function ln(e) {
    return e.$$typeof === Be;
  }

  function pn(e) {
    return e.$$typeof === Ge;
  }

  function vn(e) {
    var t = e.Component,
        r = e.displayName,
        n = e.options,
        o = e.React,
        a = e.isHookChange;
    return !function (e, t) {
      return t.exclude && t.exclude.length > 0 && t.exclude.some(function (t) {
        return t.test(e);
      });
    }(r, n) && !1 !== t.whyDidYouRender && (!a || !t.whyDidYouRender || !1 !== t.whyDidYouRender.trackHooks) && !!(t.whyDidYouRender || n.trackAllPureComponents && (t && t.prototype instanceof o.PureComponent || ln(t)) || function (e, t) {
      return t.include && t.include.length > 0 && t.include.some(function (t) {
        return t.test(e);
      });
    }(r, n));
  }

  var hn = function hn(e, t, r) {
    switch (r.length) {
      case 0:
        return e.call(t);

      case 1:
        return e.call(t, r[0]);

      case 2:
        return e.call(t, r[0], r[1]);

      case 3:
        return e.call(t, r[0], r[1], r[2]);
    }

    return e.apply(t, r);
  },
      yn = Math.max;

  var dn = function dn(e, t, r) {
    return t = yn(void 0 === t ? e.length - 1 : t, 0), function () {
      for (var n = arguments, o = -1, a = yn(n.length - t, 0), i = Array(a); ++o < a;) {
        i[o] = n[t + o];
      }

      o = -1;

      for (var c = Array(t + 1); ++o < t;) {
        c[o] = n[o];
      }

      return c[t] = r(i), hn(e, this, c);
    };
  };

  var bn = function bn(e) {
    return function () {
      return e;
    };
  },
      gn = function () {
    try {
      var e = G(Object, "defineProperty");
      return e({}, "", {}), e;
    } catch (e) {}
  }(),
      mn = gn ? function (e, t) {
    return gn(e, "toString", {
      configurable: !0,
      enumerable: !1,
      value: bn(t),
      writable: !0
    });
  } : Ar,
      _n = Date.now;

  var jn = function (e) {
    var t = 0,
        r = 0;
    return function () {
      var n = _n(),
          o = 16 - (n - r);

      if (r = n, o > 0) {
        if (++t >= 800) return arguments[0];
      } else t = 0;

      return e.apply(void 0, arguments);
    };
  }(mn);

  var On = function On(e, t) {
    return jn(dn(e, t, Ar), e + "");
  };

  var wn = function wn(e, t, r) {
    if (!A(r)) return !1;
    var n = typeof t;
    return !!("number" == n ? Et(r) && vt(t, r.length) : "string" == n && t in r) && ae(r[t], e);
  };

  var kn = function kn(e) {
    var t = [];
    if (null != e) for (var r in Object(e)) {
      t.push(r);
    }
    return t;
  },
      Dn = Object.prototype.hasOwnProperty;

  var Sn = function Sn(e) {
    if (!A(e)) return kn(e);
    var t = kt(e),
        r = [];

    for (var n in e) {
      ("constructor" != n || !t && Dn.call(e, n)) && r.push(n);
    }

    return r;
  };

  var Pn = function Pn(e) {
    return Et(e) ? Ot(e, !0) : Sn(e);
  },
      Rn = Object.prototype,
      En = Rn.hasOwnProperty,
      xn = On(function (e, t) {
    e = Object(e);
    var r = -1,
        n = t.length,
        o = n > 2 ? t[2] : void 0;

    for (o && wn(t[0], t[1], o) && (n = 1); ++r < n;) {
      for (var a = t[r], i = Pn(a), c = -1, u = i.length; ++c < u;) {
        var f = i[c],
            s = e[f];
        (void 0 === s || ae(s, Rn[f]) && !En.call(e, f)) && (e[f] = a[f]);
      }
    }

    return e;
  });

  function An(t, r, n, u) {
    var f = function (n) {
      function f(e, r) {
        var n;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, f), (n = function (e, t) {
          return !t || "object" != typeof t && "function" != typeof t ? i(e) : t;
        }(this, o(f).call(this, e, r)))._WDYR = {
          renderNumber: 0
        };
        var a = c(o(f.prototype), "render", i(n)) || n.render;
        return a !== t.prototype.render && (n.render = function () {
          return f.prototype.render.apply(i(n)), a();
        }), n;
      }

      var s, l, p;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && a(e, t);
      }(f, n), s = f, (l = [{
        key: "render",
        value: function value() {
          return this._WDYR.renderNumber++, "isStrictMode" in this._WDYR || (this._WDYR.isStrictMode = function (e) {
            for (var t = e && e._reactInternalFiber; t;) {
              if (1 & t.mode) return !0;
              t = t.return;
            }

            return !1;
          }(this)), this._WDYR.isStrictMode && this._WDYR.renderNumber % 2 == 1 || (this._WDYR.prevProps && u.notifier(fn({
            Component: t,
            displayName: r,
            prevProps: this._WDYR.prevProps,
            prevState: this._WDYR.prevState,
            nextProps: this.props,
            nextState: this.state,
            options: u
          })), this._WDYR.prevProps = this.props, this._WDYR.prevState = this.state), c(o(f.prototype), "render", this) ? c(o(f.prototype), "render", this).call(this) : null;
        }
      }]) && e(s.prototype, l), p && e(s, p), f;
    }(t);

    return f.displayName = r, xn(f, t), f;
  }

  function Nn(e, t, r, n, o) {
    var a = "string" == typeof e ? function (e, t) {
      return function (r) {
        return t.createElement(e, r);
      };
    }(e, n) : e;

    function i() {
      var e = arguments[0],
          i = n.useRef(),
          c = i.current;

      if (i.current = e, c) {
        var u = fn({
          Component: a,
          displayName: r,
          prevProps: c,
          nextProps: e,
          options: o
        }),
            f = u.reason.propsDifferences && !(t && 0 === u.reason.propsDifferences.length);
        f && o.notifier(u);
      }

      return a.apply(void 0, arguments);
    }

    return i.displayName = r, i.ComponentForHooksTracking = a, xn(i, a), i;
  }

  function Cn(e, t, r, n, o) {
    var a = t.path,
        i = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner.current,
        c = n.useRef();
    if (!i) return r;
    var u = i.type.ComponentForHooksTracking || i.type,
        f = tt(u);
    if (!vn({
      Component: u,
      displayName: f,
      options: o,
      React: n,
      isHookChange: !0
    })) return r;
    var s = c.current;

    if (c.current = r, s) {
      var l = fn({
        Component: u,
        displayName: f,
        hookName: e,
        prevHook: a ? Me(s, a) : s,
        nextHook: a ? Me(r, a) : r,
        options: o
      });
      l.reason.hookDifferences && o.notifier(l);
    }

    return r;
  }

  function Tn(e, t, r, n, o) {
    return ln(t) ? function (e, t, r, n) {
      var o = e.type,
          a = sn(o),
          i = pn(o),
          c = i ? o.render : o,
          u = a ? An(c, t, 0, n) : Nn(c, !0, t, r, n);
      u.displayName = tt(c), u.ComponentForHooksTracking = e, xn(u, c);
      var f = r.memo(i ? r.forwardRef(u) : u, e.compare);
      return f.displayName = t, xn(f, e), f;
    }(t, r, n, o) : pn(t) ? function (e, t, r, n) {
      var o = e.render,
          a = ln(o),
          i = a ? o.type : o,
          c = Nn(i, a, t, r, n);
      c.displayName = tt(i), c.ComponentForHooksTracking = i, xn(c, i);
      var u = r.forwardRef(a ? r.memo(c, o.compare) : c);
      return u.displayName = t, xn(u, e), u;
    }(t, r, n, o) : sn(t) ? An(t, r, 0, o) : Nn(t, !1, r, n, o);
  }

  function Hn(e, t, r, n, o) {
    if (e.has(t)) return e.get(t);
    var a = Tn(0, t, r, n, o);
    return e.set(t, a), a;
  }

  var Yn = {
    useState: {
      path: "0"
    },
    useReducer: {
      path: "0"
    },
    useContext: !0,
    useMemo: !0
  };

  function zn(e, t) {
    var r = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = console.group,
          r = console.groupEnd;
      e.collapseGroups ? t = console.groupCollapsed : e.onlyLogs && (t = console.log, r = Ze);
      var o = e.notifier || Xe("hotReloadBufferMs" in e ? e.hotReloadBufferMs : 500);
      return n({
        include: null,
        exclude: null,
        notifier: o,
        onlyLogs: !1,
        consoleLog: console.log,
        consoleGroup: t,
        consoleGroupEnd: r,
        logOnDifferentValues: !1,
        trackHooks: !0,
        titleColor: "#058",
        diffNameColor: "blue",
        diffPathColor: "red",
        trackExtraHooks: [],
        trackAllPureComponents: !1
      }, e);
    }(t),
        o = e.createElement,
        a = e.createFactory,
        i = new WeakMap();

    if (e.createElement = function (t) {
      for (var n = null, a = null, c = null, u = arguments.length, f = new Array(u > 1 ? u - 1 : 0), s = 1; s < u; s++) {
        f[s - 1] = arguments[s];
      }

      try {
        if (n = ("function" == typeof t || ln(t) || pn(t)) && vn({
          Component: t,
          displayName: tt(t),
          React: e,
          options: r
        })) return a = t && t.whyDidYouRender && t.whyDidYouRender.customName || tt(t), c = Hn(i, t, a, e, r), o.apply(e, [c].concat(f));
      } catch (e) {
        r.consoleLog("whyDidYouRender error. Please file a bug at https://github.com/welldone-software/why-did-you-render/issues.", {
          errorInfo: {
            error: e,
            componentNameOrComponent: t,
            rest: f,
            options: r,
            isShouldTrack: n,
            displayName: a,
            WDYRPatchedComponent: c
          }
        });
      }

      return o.apply(e, [t].concat(f));
    }, Object.assign(e.createElement, o), e.createFactory = function (t) {
      var r = e.createElement.bind(null, t);
      return r.type = t, r;
    }, Object.assign(e.createFactory, a), r.trackHooks) {
      var c = Object.entries(Yn).map(function (t) {
        var r = u(t, 2),
            n = r[0],
            o = r[1];
        return [e, n, o];
      });
      [].concat(f(c), f(r.trackExtraHooks)).forEach(function (t) {
        var n = u(t, 3),
            o = n[0],
            a = n[1],
            i = n[2],
            c = void 0 === i ? {} : i,
            f = o[a],
            s = a[0].toUpperCase() + a.slice(1),
            l = function l() {
          for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++) {
            n[o] = arguments[o];
          }

          var i = f.call.apply(f, [this].concat(n));
          return Cn(a, c, i, e, r), i;
        };

        Object.defineProperty(l, "name", {
          value: s,
          writable: !1
        }), Object.assign(l, {
          originalHook: f
        }), o[a] = l;
      });
    }

    return e.__REVERT_WHY_DID_YOU_RENDER__ = function () {
      Object.assign(e, {
        createElement: o,
        createFactory: a
      }), i = null, [].concat(f(Object.keys(Yn).map(function (t) {
        return [e, t];
      })), f(r.trackExtraHooks)).forEach(function (e) {
        var t = u(e, 2),
            r = t[0],
            n = t[1];
        r[n].originalHook && (r[n] = r[n].originalHook);
      }), delete e.__REVERT_WHY_DID_YOU_RENDER__;
    }, e;
  }

  return zn.defaultNotifier = Qe, zn;
});